import React, { useState } from 'react';

import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import CommonMiniModal from 'components/CommonMiniModal';

const ctx = document.querySelector('#showPopup');

export const ShowMiniProgramModal = (props) => {
  const { username, imgUrl, path, isProd = true } = props || {};
  const ContentView = () => {
    const [showMiniModal, setShowMiniModal] = useState(true);
    if (!showMiniModal) {
      return null;
    }
    return (
      <CommonMiniModal
        {...{
          visible: showMiniModal,
          onClose: () => setShowMiniModal(false),
          path: path,
          imgUrl: imgUrl,
          username: username,
          isProd: isProd
        }}
      />
    );
  };
  ReactDOM.render(<ContentView />, ctx);
};

ShowMiniProgramModal.propTypes = {
  // 小程序原始ID
  username: PropTypes.string,
  // 跳转路径
  path: PropTypes.string,
  // 弹窗图片
  imgUrl: PropTypes.string,
  // 是否唤起正式版，false 唤起体验版
  isProd: PropTypes.bool
};
ShowMiniProgramModal.defaultProps = {
  // 小程序原始ID
  username: '',
  // 跳转路径
  path: '',
  // 弹窗图片
  imgUrl: '',
  // 默认唤起正式版，保持既有调用方行为不变
  isProd: true
};



// WEBPACK FOOTER //
// ./src/components/MiniProgramModal/index.js